import moment from 'moment';
import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import config from '../config';

export function showLoginForm({ path }) {
	return async dispatch => {
		if (['development', 'testing', 'testing2'].indexOf(process.env.NODE_ENV) !== -1) {
			dispatch({
				type: ActionTypes.LOGIN_PAGE_SHOW_LOGIN_FORM
			});
			return;
		}
		const res = await API.auth.getCasUrl({ path });
		if (res.meta.code !== 200) {
			return;
		}
		window.location.href = res.data.url;
	};
}

export function onFieldChange(fieldName, fieldValue) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.UPDATE_LOGIN_PAGE_FORM_FIELD,
			payload: {
				fieldName,
				fieldValue
			}
		});
	};
}

export function login({ email, query }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.LOGIN_REQUEST
		});

		// uncomemnt if login api is ready
		const res = await API.auth.login(email);

		if (res.meta.code !== 200) {
			dispatch({
				type: ActionTypes.LOGIN_ERROR,
				payload: {
					error: res.meta.message
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.LOGIN_SUCCESS
		});

		// store response
		localStorage.setItem(
			'cso_transport_booking_app',
			JSON.stringify({
				token: res.data.auth.token,
				booker: res.data.booker,
				last_login: moment()
			})
		);

		if (query && query.path && query.path !== '/' && query.path !== '') {
			if (query.path.includes('login') || query.path.includes('logout')) {
				dispatch(push('/bookings'));
				return;
			}
			dispatch(push(query.path));
		} else {
			// Navigate to next page
			dispatch(push('/applications'));
		}
	};
}

export function reset() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_LOGIN_PAGE
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_LOGIN_PAGE_META
		});
	};
}
